/** Skeleton do Dossiê do dia — header + lista de pacientes. */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-3xl animate-pulse flex-col gap-6">
      <div className="h-[104px] rounded-[20px] bg-slate-200" />
      <div className="flex items-center justify-between">
        <div className="h-4 w-40 rounded bg-slate-100" />
        <div className="h-9 w-44 rounded-xl bg-slate-200" />
      </div>
      <div className="flex flex-col gap-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-center gap-2">
              <div className="h-4 w-10 rounded bg-slate-200" />
              <div className="h-4 w-40 rounded bg-slate-200" />
            </div>
            <div className="mt-3 h-3 w-full rounded bg-slate-100" />
            <div className="mt-1.5 h-3 w-3/4 rounded bg-slate-100" />
          </div>
        ))}
      </div>
    </div>
  );
}
